import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { BackgroundGradient, Button, MFAModal, Loader, SafeAreaView, Storage, Alert } from '../../components';
import * as rtApi from '../../components/Api';
import { useFocusEffect } from '@react-navigation/native';
// import { formatAmountDisplay } from '../../utils/Functions';
import * as LocalAthentication from 'expo-local-authentication';
// import * as SecureStore from 'expo-secure-store';
import UserState from '../../src/contexts/UserState';
import { formatAmount } from '../../utils/Functions';
import { useLinkTo } from '@react-navigation/native';
import { FontAwesome5 } from '@expo/vector-icons';

export default function Estimate({ navigation }) {
  const [user, setUser] = React.useContext(UserState);
  const [alertOptions, setAlertOptions] = React.useState({});

  const [loading, setLoading] = React.useState(false);
  const [id, setId] = React.useState(0);
  const [balance, setBalance] = React.useState([]);
  const [fee, setFee] = React.useState([]);
  const [tax, setTax] = React.useState([]);
  const [total, setTotal] = React.useState([]);
  const [address, setAddress] = React.useState([]);
  const [name, setName] = React.useState([]);
  const [amount, setAmount] = React.useState(0);

  const [showMFA, setShowMFA] = React.useState(false);
  const [MFACode, setMFACode] = React.useState(null);
  const [MFARequired, setMFARequired] = React.useState(false);

  const linkTo = useLinkTo();

  React.useEffect(() => {
    checkMFACode();
  }, [MFACode])

  useFocusEffect(
    React.useCallback(() => {
      getEstimate();
    }, [])
  );

  const getEstimate = () => {
    setLoading(true);
    rtApi.post('money/estimate')
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setData(data.estimate);
      console.log('money estimate', data);
    }).catch(err => {
      console.log('error: ', err);
    }).finally(() => {
      setLoading(false);
    });
  }
  const setData = (e) => {
    setId(e.Id);
    setBalance(e.balance);
    setFee(e.fee);
    setTax(e.tax);
    setTotal(e.total);
    setAddress(e.address);
    setName(e.name);
    setAmount(formatAmount(e.total[1], false));
  }

  const confirmWithdrawal = async () => {
    console.log('confirm ??');
    // callMFA(); // testing
    // showSuccessAlert();
    // return;

    let hasHardwareAsync = await LocalAthentication.hasHardwareAsync();
    // let hasHardwareAsync = false; //testing mfa
    console.log('hasHardwareAsync', hasHardwareAsync);
    // const useLocalResult = await SecureStore.getItemAsync('useLocalAuthentication');
    const useLocalResult = await Storage.getItem('useLocalAuthentication');
    if (hasHardwareAsync && (useLocalResult && useLocalResult === 'yes')) {
      let supportedAuthenticationTypesAsync = await LocalAthentication.supportedAuthenticationTypesAsync();
      console.log('supportedAuthenticationTypesAsync', supportedAuthenticationTypesAsync);
      if (supportedAuthenticationTypesAsync.length !== 0) {
        let isEnrolledAsync = await LocalAthentication.isEnrolledAsync();
        console.log('isEnrolledAsync', isEnrolledAsync);
        if (isEnrolledAsync) {
          let authenticateAsync = await LocalAthentication.authenticateAsync({
            promptMessage: 'Confirm withdrawal of funds.'
          });
          console.log('authenticateAsync', authenticateAsync);
          if (authenticateAsync.success) {
            withdraw()
          }
        }
      }
    } else {
      console.log('MFA goes here');
      // setShowMFA(true);
      // setMFARequired(true);
      callMFA();
    }
  }

  const callMFA = () => {
    setLoading(true);
    let fd = new FormData();
    if (MFARequired && MFACode) {
      fd.append('MFA', MFACode);
      setMFACode(null);
    }
    rtApi.post('money', fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      if (data.MFA) {
        setShowMFA(true);
        setMFARequired(true);
      } else {
        setMFARequired(false);
        showSuccessAlert();
      }
    }).catch(err => {
      console.log('call mfa error', err);
      setMFACode(null);
      setShowMFA(true);
    }).finally(() => {
      setLoading(false);
    });
  }
  const checkMFACode = () => {
    console.log('MFACode', MFACode);
    if (String(MFACode).length === 6) {
      setShowMFA(false);
      if (MFARequired) {
        callMFA();
      }
    }
  }

  const withdraw = () => {
    setLoading(true);
    let fd = new FormData();
    if (MFARequired && MFACode) {
      fd.append('MFA', MFACode);
      setMFACode(null);
    }
    rtApi.post('money', fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setTimeout(() => { showSuccessAlert(); }, 10);
    }).catch(err => {
      console.log('call mfa error', err);
    }).finally(() => {
      setLoading(false);
    });
  }

  const showSuccessAlert = () => {
    setAlertOptions({
      visible: true,
      title: 'Success',
      message: 'Your cheque will be prepared momentarily',
      buttons: [
        {
          text: "Ok",
          onPress: () => goBack(),
        },
      ],
    });
  }
  const cancelMFA = () => {
    setShowMFA(false);
    setMFACode(null);
    setMFARequired(false);
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/money');
    }
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <MFAModal
        show={showMFA}
        cancel={cancelMFA}
        setMFACode={setMFACode}
        showTrusted={false}
      />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <View style={CS.innerContainer}>
        <TouchableOpacity onPress={goBack} style={styles.backArrow}>
          <FontAwesome5 name="arrow-left" size={24} color="white" />
        </TouchableOpacity>
        {/* balance */}
        <View style={[CS.rowContainer, styles.row]}>
          <Text style={[CS.smallText, CS.boldText, CS.lightBlueText]}>{balance[0]}</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.amount]}>{balance[1]}</Text>
        </View>
        {/* fee */}
        <View style={[CS.rowContainer, styles.row]}>
          <Text style={[CS.smallText, CS.boldText, CS.lightBlueText]}>{fee[0]}</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.amount]}>-{fee[1]}</Text>
        </View>
        {/* tax */}
        <View style={[CS.rowContainer, styles.row]}>
          <Text style={[CS.smallText, CS.boldText, CS.lightBlueText]}>{tax[0]}</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.amount]}>-{tax[1]}</Text>
        </View>
        {/* total */}
        <View style={styles.totalContainer}>
          {/* <Text style={[CS.smallText, CS.boldText, CS.lightText]}>{total[0]}</Text> */}
          <Text style={[CS.smallText, CS.lightText, styles.total]}>{total[1]}</Text>
        </View>
        {/* blurb */}
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>A cheque for {total[1]} will be made payable to:</Text>
        <View style={styles.tile}>
          <Text style={[CS.smallText, CS.lightText, CS.boldText, { marginBottom: 2 }]}>{name}</Text>
          {address.map((a, i) => {
            return (
              <Text style={[CS.smallText, CS.lightText, { marginBottom: 2 }]} key={i}>{a}</Text>
            )
          })}
        </View>
        <Button text='Withdraw My Funds' onPress={() => confirmWithdrawal} style={styles.withdrawButton} disabled={amount < 0} />
      </View>
    </SafeAreaView>
  );


}

const styles = StyleSheet.create({
  row: {
    marginBottom: 5,
    padding:5,
  },
  totalContainer: {
    marginBottom: 20,
    padding: 5,
  },
  amount: {
    marginLeft: 'auto',
  },
  withdrawButton: {
    marginVertical: 10,
    marginTop: Platform.OS === 'web' ? 10 : 'auto',
  },
  total: {
    textAlign: 'center',
    marginTop: 20,
    fontSize: 66,
  },
  backArrow: {
    ...Platform.select({
      web: {
        position: 'absolute',
        top: 0,
        left: 0,
      }
    }),
    marginVertical: 20,
  },
  tile: {
    padding: 15,
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    marginBottom: 10,
    backgroundColor: Colors.textInputBackground,
  },
});
